import { takeLatest, call, put } from 'redux-saga/effects';
import { getUrgencyStatements } from 'yoda-interfaces/lib/UrgencyMessaging/UrgencyMessagingApi';
import isEmpty from 'lodash/isEmpty';
import {
    URGENCY_MESSAGING_GET_SUCCESS,
    URGENCY_MESSAGING_GET_REQUEST,
} from '../actionTypes/UrgencyMessagingActionTypes';

function* UrgencyMessagingSaga(action) {
    try {
        const urgencyStatements = yield call(
            getUrgencyStatements,
            action.payload.ppid,
            action.payload.apiURL
        );
        if (!isEmpty(urgencyStatements)) {
            yield put({ type: URGENCY_MESSAGING_GET_SUCCESS, urgencyStatements });
        }
    } catch (error) {
        yield put({ type: 'CONTENT_ERROR', error });
    }
}

const watchUrgencyMessagingSaga = function* watchUrgencyMessagingSaga() {
    yield takeLatest(URGENCY_MESSAGING_GET_REQUEST, UrgencyMessagingSaga);
};
watchUrgencyMessagingSaga.sagaName = 'watchUrgencyMessagingSaga';

export default watchUrgencyMessagingSaga;
